/**
 * Product media gallery - Load More button
 * Reveals hidden product images when Load More is clicked
 */
document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-product-media-load-more]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const mediaGallery = btn.closest('media-gallery');
    if (!mediaGallery) return;

    const list = mediaGallery.querySelector('.product__media-list');
    if (!list) return;

    const hiddenItems = list.querySelectorAll('.product__media-item--load-more-hidden');
    if (!hiddenItems.length) return;

    hiddenItems.forEach((item) => item.classList.remove('product__media-item--load-more-hidden'));

    const loadMoreWrapper = btn.closest('.product__media-load-more');
    if (loadMoreWrapper) loadMoreWrapper.classList.add('is-loaded');

    // Force layout recalc so newly visible items display correctly
    list.offsetHeight;
    window.dispatchEvent(new Event('resize'));
  });
});
